import React, { Component } from 'react';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { Card } from 'reactstrap';
import { connect } from 'react-redux';
import { Query } from 'react-apollo';
import Spinner from '~/components/spinner/spinner';
import AgendaLotEventDetailModal from '~/containers/agendaLotEventDetailModal/agendaLotEventDetailModal';
import AgendaItemSummary from '~/components/agendaItemSummary/agendaItemSummary';
import { getAgendaQuery } from '../agenda/agenda';
import ErrorBoundaryContent from '~/components/errorBoundary/content';
import styles from './styles.css';

const mushEvents = events =>
  events.map(event => {
    const day = moment(event.date);
    return {
      start: day,
      end: day,
      allDay: true,
      resource: event
    };
  });

export class TodaysAgendaList extends Component {
  state = {
    selectedEvent: null
  };

  onModalToggle = () => {
    this.setState({
      selectedEvent: null
    });
  };

  onSelectEvent = selectedEvent => {
    this.setState({
      selectedEvent
    });
  };

  classNameForEvent = event => {
    if (event.resource.type === 'LOT_TRANSFER') {
      switch (event.resource.lotTransfer.type) {
        case 'TANK':
          return { className: styles.tank };
        case 'VESSEL':
          return { className: styles.vessel };
        case 'LOCATION':
          return { className: styles.location };
        case 'DRY_HOP':
          return { className: styles.dryHop };
        case 'CLARIFICATION':
          return { className: styles.clarification };
        default:
          return null;
      }
    }
    if (event.resource.type === 'SCHEDULED_LOT') {
      return { className: styles.scheduledLot };
    }

    return null;
  };

  render() {
    const { brewery } = this.props;
    const { selectedEvent } = this.state;
    return (
      <Query
        query={getAgendaQuery}
        variables={{
          breweryId: brewery.id,
          startDate: moment().format('YYYY-MM-DD'),
          endDate: moment().format('YYYY-MM-DD')
        }}
        fetchPolicy={'cache-and-network'}
      >
        {props => {
          const { loading, error, data } = props;
          if (loading) {
            return <Spinner className="absolute absolute-center stroke-brand-red" />;
          }

          if (error) {
            return <ErrorBoundaryContent error={error} />;
          }

          const events = mushEvents(data.agenda);
          return (
            <div className={`content ${styles.container}`}>
              <Card className="content pa3">
                <h3 className="h5 h-auto">Things that are happening today:</h3>
                <div>
                  {events && events.length ? (
                    events.map((event, idx) => <AgendaItemSummary key={idx} event={event} />)
                  ) : (
                    <p className="mt2">
                      Nothing! Nothing is on the <Link to="/agenda">agenda</Link> to be done today.
                    </p>
                  )}
                </div>
              </Card>
              <AgendaLotEventDetailModal
                isOpen={!!selectedEvent}
                lotId={selectedEvent ? selectedEvent.resource.lotId : null}
                event={selectedEvent ? selectedEvent : null}
                onToggle={this.onModalToggle}
              />
            </div>
          );
        }}
      </Query>
    );
  }
}

function mapStateToProps(state) {
  return {
    brewery: state.brewery
  };
}

export default connect(mapStateToProps)(TodaysAgendaList);



// WEBPACK FOOTER //
// ./src/containers/todaysAgendaList/todaysAgendaList.jsx